module.exports = __webpack_public_path__ + "img/elife_yuzhe_2021.7b0cae29.jpg";